import type { Metric } from "web-vitals";

import { errorReporter } from "../services/errorReporter";

export const sendToAnalytics = (metric: Metric): void => {
  const level = metric.rating === "poor" ? "warn" : "info";

  errorReporter.notify({
    message: `Web Vitals: ${metric.name}`,
    level,
    context: {
      metric: metric.name,
      value: metric.value,
      delta: metric.delta,
      rating: metric.rating,
      id: metric.id,
      navigationType: metric.navigationType,
    },
  });
};
